(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-complementary-product"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(complementaryProductsSection);

    const url = complementaryProductsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations_complementary');

        if (recommendations && recommendations.innerHTML.trim().length) {
          complementaryProductsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const complementaryProductsSection = document.querySelector('.product-recommendations_complementary');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(complementaryProductsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-related-products"] && !Shopify.designMode) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(relatedProductsSection);

        const url = relatedProductsSection.dataset.url;
        const featuredCollection = relatedProductsSection.dataset.featuredCollection;
        
        fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations_related');

            if (recommendations && recommendations.innerHTML.trim().length) {
                relatedProductsSection.innerHTML = recommendations.innerHTML;
                
                // Re-apply featured collection after AJAX load if needed
                if (featuredCollection) {
                    // Use the ajax-grid template view instead of section_id parameter
                    fetch(`/collections/${featuredCollection}?view=ajax-grid`)
                    .then(response => response.text())
                    .then(collectionText => {
                        const collectionHtml = document.createElement('div');
                        collectionHtml.innerHTML = collectionText;

                        // Get current product ID to filter it out
                        let currentProductId;
                        try {
                            currentProductId = parseInt(relatedProductsSection.dataset.currentProductId || '0', 10);
                        } catch (error) {
                            currentProductId = 0;
                        }
                        
                        // Get featured collection products
                        const allFeaturedProducts = Array.from(collectionHtml.querySelectorAll('.ajax-product-item'));
                        
                        // Filter out the current product from featured collection
                        const featuredProducts = allFeaturedProducts.filter(item => {
                            const itemProductId = parseInt(item.getAttribute('data-product-id'), 10);
                            return itemProductId !== currentProductId;
                        });
                        
                        if (featuredProducts.length > 0) {
                            const productsWrapper = document.querySelector('.related_products-wrapper');
                            
                            // Get all existing algorithmic recommendation products
                            const algoProducts = productsWrapper.querySelectorAll('li.swiper-slide');
                            
                            // Total product limit from settings
                            const productLimit = parseInt('{{ section.settings.products_to_show | json }}', 10) || 10;
                            const featuredToAdd = Math.min(featuredProducts.length, productLimit);
                            const remainingSlots = productLimit - featuredToAdd;
                            productsWrapper.innerHTML = '';
                            
                            for (let i = 0; i < featuredToAdd; i++) {
                                productsWrapper.appendChild(featuredProducts[i].cloneNode(true));
                            }
                            
                            if (remainingSlots > 0) {
                                for (let i = 0; i < Math.min(algoProducts.length, remainingSlots); i++) {
                                    productsWrapper.appendChild(algoProducts[i].cloneNode(true));
                                }
                            }
                            
                            // Re-initialize swiper after adding products
                            relatedProudctsSlide();
                            // dispatch custom event to notify that products have been loaded
                            document.dispatchEvent(new CustomEvent('related-products-loaded'));
                        }
                    })
                    .catch(error => {
                        console.error('Error loading featured collection:', error);
                    });
                }
            }
        })
        .catch(e => {
            console.error(e);
        });
    };

    const relatedProductsSection = document.querySelector('.product-recommendations_related');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(relatedProductsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 834px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-pdp-info-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-pdp-info-sticky');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-pdp-info-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searhModal){
        this.searchModal.close(false);
      }

    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["not-found-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const notFoundBanner = document.querySelector('.l-not-found-section');
    const hasNotFound = window.location.search.includes('notfound=');

    if (notFoundBanner && hasNotFound) {
      if (window.location.search.includes('notfound=1')) {
        notFoundBanner.querySelector('h5').textContent = 'Oops! This one’s gone...';
        notFoundBanner.querySelector('p').textContent = 'It flew off the shelves, but we’ve got plenty more you’ll love.';
      } else {
        notFoundBanner.querySelector('h5').textContent = 'Oops! Page not found';
        notFoundBanner.querySelector('p').textContent = '';
      }

      notFoundBanner.style.display = 'block';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const textSliders = document.querySelectorAll('.text-slider');

    textSliders.forEach(slider => {
      const inner = slider.querySelector('.text-slider-inner');
      const items = inner.querySelectorAll('.text-slider-item');

      if (items.length === 0 || window.innerWidth > 870) return;

      items.forEach(item => {
        const clone = item.cloneNode(true);
        inner.appendChild(clone);
      });

      let currentOffset = 0;
      const itemHeight = 22;
      const totalItems = items.length;

      setInterval(() => {
        currentOffset -= itemHeight;

        // reset when we've scrolled through all original items
        if (Math.abs(currentOffset) >= totalItems * itemHeight) {
          currentOffset = 0;
        }

        inner.style.transform = `translateY(${currentOffset}px)`;
      }, 2500);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
